import React from "react";
import ReactDOM from "react-dom";
import "./styles/globals.css";
import Moved from "./pages/Moved";

ReactDOM.render(
    <React.StrictMode>
        <Moved />
    </React.StrictMode>,
    document.getElementById("root")
);
